import { Box, IconButton } from "@mui/material"
import { EditOutlined } from "@mui-symbols-material/w300"
import type { ColumnDef } from "@tanstack/react-table"
import React from "react"

import DateChip from "@/components/DateChip"
import type { Category } from "@/graphql/codegen/graphql"
import TableCellWithId from "@/screens/ManageProducts/components/Instructions/components/tables/TableCellWithId"

export const useProductCategoriesColumns = ({
  onOpenEditCategoryDialog,
}: {
  onOpenEditCategoryDialog: (original: Category) => void
}): ColumnDef<Category>[] => {
  return [
    {
      accessorKey: "name",
      header: "Product Category",
      sortingFn: "alphanumeric",
      cell: ({ row }) => (
        <div className='flex grow items-center gap-2'>
          <TableCellWithId id={row.original.externalSystemId}>{row.original.name}</TableCellWithId>
        </div>
      ),
      minSize: 200,
      enableSorting: true,
    },
    {
      accessorKey: "createdOn",
      header: "Created",
      cell: ({ row }) => <DateChip date={row.original.createdOn} />,
      enableSorting: true,
      size: 50,
    },
    {
      accessorKey: "updatedOn",
      header: "Updated",
      cell: ({ row }) => <DateChip date={row.original.updatedOn} />,
      enableSorting: true,
      size: 50,
    },
    {
      accessorKey: "actions",
      header: "",
      cell: ({ row }) => (
        <Box className='flex flex-row items-center justify-end'>
          <IconButton
            size='small'
            className='ml-4'
            aria-label='Edit'
            onClick={() => onOpenEditCategoryDialog(row.original)}
            data-test='edit-category'
          >
            <EditOutlined className='h-5' />
          </IconButton>
        </Box>
      ),
      size: 50,
      enableSorting: false,
    },
  ]
}
